import { render, staticRenderFns } from "./FollowUpModal.vue?vue&type=template&id=cd4f56a0"
import script from "./FollowUpModal.vue?vue&type=script&lang=js"
export * from "./FollowUpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports